import type { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import type { OverlayPosition, ColumnValue } from '@core/prosemirror-legacy';
import { ColumnsMenuController } from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { ColumnsMenuComponent } from './columns-menu.component';

@Injectable()
export class ColumnsMenuService
  extends WysiwygComponentPortalService<ColumnsMenuComponent>
  implements ColumnsMenuController
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(
    position: OverlayPosition | DOMRect,
    _options: {
      getActive: () => ColumnValue;
      select: (val: ColumnValue) => void;
      preferredPositions?: ConnectedPosition[];
    },
  ) {
    const options = {
      preferredPositions: _options.preferredPositions || [
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
      ],
    };
    this.close();
    this.openComponent(ColumnsMenuComponent, position, options.preferredPositions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.close = () => this.close();
    instance.getActive = _options.getActive;
    instance.select = _options.select;

    this.componentRef?.changeDetectorRef.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }
}
